'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AuthService = AuthService;

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var _User = function _User() {
  _classCallCheck(this, _User);

  this._id = '';
  this.name = '';
  this.email = '';
  this.role = '';
  this.$promise = undefined;
};

function AuthService($location, $http, $cookies, $q, appConfig, Util, User) {
  'ngInject';

  var safeCb = Util.safeCb;
  var currentUser = new _User();
  var userRoles = appConfig.userRoles || [];

  var _hasRole = function _hasRole(userRole, role) {
    return userRoles.indexOf(userRole) >= userRoles.indexOf(role);
  };

  if ($cookies.get('token') && $location.path() !== '/logout') {
    currentUser = User.get();
  }

  var Auth = {
    login: function login(_ref, callback) {
      var email = _ref.email,
          password = _ref.password;

      return $http.post('/auth/local', {
        email: email,
        password: password
      }).then(function (res) {
        $cookies.put('token', res.data.token);
        currentUser = User.get();
        return currentUser.$promise;
      }).then(function (user) {
        safeCb(callback)(null, user);
        return user;
      }).catch(function (err) {
        Auth.logout();
        safeCb(callback)(err.data);
        return $q.reject(err.data);
      });
    },
    logout: function logout() {
      $cookies.remove('token');
      currentUser = new _User();
    },
    createUser: function createUser(user, callback) {
      return User.save(user, function (data) {
        console.log(data);
        return safeCb(callback)(null, user);
      }, function (err) {
        Auth.logout();
        return safeCb(callback)(err);
      }).$promise;
    },
    changePassword: function changePassword(oldPassword, newPassword, callback) {
      return User.changePassword({
        id: currentUser._id
      }, {
        oldPassword: oldPassword,
        newPassword: newPassword
      }, function () {
        return safeCb(callback)(null);
      }, function (err) {
        return safeCb(callback)(err);
      }).$promise;
    },
    getCurrentUser: function getCurrentUser(callback) {
      var value = _.get(currentUser, '$promise') ? currentUser.$promise : currentUser;

      return $q.when(value).then(function (user) {
        safeCb(callback)(user);
        return user;
      }, function () {
        safeCb(callback)({});
        return {};
      });
    },
    getCurrentUserSync: function getCurrentUserSync() {
      return currentUser;
    },
    isLoggedIn: function isLoggedIn(callback) {
      return Auth.getCurrentUser(undefined).then(function (user) {
        var is = _.get(user, 'role');

        safeCb(callback)(is);
        return is;
      });
    },
    isLoggedInSync: function isLoggedInSync() {
      return !!_.get(currentUser, 'role');
    },
    isNotFreightSync: function isNotFreightSync() {
      var is = _.get(currentUser, 'role');
      return is === 'user' || is === 'admin';
    },
    hasRole: function hasRole(role, callback) {
      return Auth.getCurrentUser(undefined).then(function (user) {
        var has = _hasRole(_.get(user, 'role'), role);

        safeCb(callback)(has);
        return has;
      });
    },
    hasRoleSync: function hasRoleSync(role) {
      return _hasRole(_.get(currentUser, 'role'), role);
    },
    isAdmin: function isAdmin() {
      return Auth.hasRole.apply(Auth, _toConsumableArray([].concat.apply(['admin'], arguments)));
    },
    isAdminSync: function isAdminSync() {
      return Auth.hasRoleSync('admin');
    },
    getToken: function getToken() {
      return $cookies.get('token');
    }
  };

  return Auth;
}


// WEBPACK FOOTER //
// ./client/components/auth/auth.service.js